var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleSoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0a7.5 7.5 0 10.001 15.001A7.5 7.5 0 007.5 0zm2.796 10.607c-.68.626-1.607.995-2.714.995a4.099 4.099 0 01-4.1-4.102 4.102 4.102 0 014.1-4.103c1.105 0 2.032.407 2.744 1.068L9.15 5.642a2.214 2.214 0 00-1.567-.613c-1.068 0-1.972.722-2.295 1.69a2.467 2.467 0 00-.13.781c0 .271.047.534.13.78.323.97 1.227 1.691 2.293 1.691.552 0 1.021-.146 1.388-.392.435-.291.723-.725.819-1.239H7.582V6.753h3.862c.049.27.074.55.074.84 0 1.25-.447 2.3-1.222 3.014z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSoc);
export default __webpack_public_path__ + "static/media/google-soc.14ce2477e7c7ce251522c9906783da92.svg";
export { ForwardRef as ReactComponent };